var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',[_vm._v("Date Range")]),_c('input-date-range',{staticClass:"form-control date-range",attrs:{"placeholder":""},model:{value:(_vm.dateRange),callback:function ($$v) {_vm.dateRange=$$v},expression:"dateRange"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }